<template>
  <div class="register container" :class="{height:codeshow}">
    <div class="wrapper">
      <a class="logo" href="http://www.tuling123.com/"></a>
      <div class="con-wrap">
        <div class="tit-box">
          <p class="tit active" @click="changePage(1)">账号注册</p>
        </div>
        <div class="wrong" :class="{active:errorMsg!==''}">{{errorMsg}}</div>
        <div>
          <div class="necessary"><input type="text" placeholder="手机号" v-model="telphone"></div>
          <input type="text" placeholder="邮箱" v-model="email">
          <div class="necessary"><input type="password" placeholder="密码" v-model="password"></div>
          <div class="necessary">
             <div class="yz">
               <input type="text" placeholder="验证码" v-model="code" class="yz-inp">
               <button class="yz-btn" @click="sendyzm" >{{sendMsg}}</button>
             </div>
          </div>
          <div class="jtocode" v-show="codeshow" ref="jcode"></div>
        </div>
        <div class="read">
          <span>
              <label for="sel">
                <input type="checkbox" @click="trackAgreement" name="" id="sel" v-model="onoff">
                <span class="selbox" :class="onoff ? 'active' : ''" ></span>阅读并同意
          </label>
          <span class="col" @click.stop="alertFn">《图灵机器人开放平台服务协议》</span>
          <span class="col" style="display: block; padding-left: 85px; padding-top: 8px;" @click.stop="alertFn1">《图灵机器人开放平台隐私权政策》</span>
          </span>
        </div>
        <div class="login-btn" @click="submit">注册</div>
        <div class="hrefs clearfix">
          <router-link :to="{ name: 'login'}"><span>已有账号？</span>登录</router-link>
        </div>
      </div>
    </div>
    <agreement v-on:close="close" :alertshow="alertshow" v-on:agree="agree" v-on:unagree="unagree"></agreement>
    <user-agreement v-on:close1="close1" :alertshow1="alertshow1" v-on:agree1="agree1" v-on:unagree1="unagree1"></user-agreement>
  </div>
</template>

<script>
  import agreement from '../agreement/agreement.vue';
  import userAgreement from '../agreement/userAgreement.vue';
  import '../../js/geetest.js';
  import $ from 'jquery';
  import mixin from '../../js/public.js';

  export default{
    mixins: [mixin],
    data () {
        return {
          errorMsg: '',
          email: '',
          password: '',
          telphone: '',
          code: '',
          id: '',
          codeshow: false,
          sendMsg: '发送验证码',
          onoff: false,
          alertshow: false,
          alertshow1: false,
          msg: '恭喜你，注册成功！',
          type: '',
          page: 1,
          isRead: false
        };
      },
      created () {
        var _this = this;
        this.id = this.uuid();
        this.$nextTick(function () {
          document.getElementsByTagName('title')[0].innerHTML = '注册';
        });
      },
      components: {
        agreement,
        userAgreement
      },
      methods: {
        changePage (n) {
          this.page = n;
          this.codeshow = false;
          this.errorMsg = '';
        },
        getJy () {
          var _this = this;
          if (this.$refs.jcode.innerHTML) {
            return;
          }
          $.ajax({
            url: _this.baseUrl + '/geetest/v3',
            type: 'POST',
            dataType: 'json',
            data: {id: _this.id},
            xhrFields: {
              withCredentials: true
            },
            success: function (res) {
              if (res.type === 'success') {
                window.initGeetest({
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.new_captcha,
                  product: 'popup',
                  width: '100%',
                  offline: !res.data.success
                }, _this.handlerPopup);
              }
            }
          });
        },
        agree () {
          this.onoff = true;
          this.alertshow = false;
        },
        agree1 () {
          this.onoff = true;
          this.alertshow1 = false;
        },
        unagree () {
          this.onoff = false;
          this.alertshow = false;
        },
        unagree1 () {
          this.onoff = false;
          this.alertshow1 = false;
        },
        close () {
          this.alertshow = false;
        },
        close1 () {
          this.alertshow1 = false;
        },
        alertFn () {
          this.alertshow = true;
          this.isRead = true;
        },
        alertFn1 () {
          console.log('隐私');
          this.alertshow1 = true;
          this.isRead = true;
        },
        trackAgreement () {
           if (window._czc) {
             window._czc.push(['_trackEvent', '阅读并同意', '点击', '阅读并同意', '1', '阅读并同意']);
           }
        },
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onReady(function () {
            setTimeout(function () {
              document.getElementsByClassName('geetest_radar_btn')[0].click();
            }, 16);
          });
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            _this.errorMsg = '';
            setTimeout(function () {
              _this.codeshow = false;
            }, 1500);
            _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}).then(function (res) {
              if (res.body.type === 'success') {
                if (res.body.data) {
                  _this.errorMsg = '该手机号已经注册';
                  captchaObj.reset();
                } else {
                  $.ajax({
                    url: _this.baseUrl + '/register/semd/4',
                    type: 'POST',
                    dataType: 'json',
                    data: {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone},
                    xhrFields: {
                      withCredentials: true
                    },
                    success: function (data) {
                      if (data.type === 'success') {
                        _this.errorMsg = '';
                        _this.toCode();
                        captchaObj.reset();
                      } else {
                        _this.errorMsg = '操作频繁，请稍后再试';
                      }
                    }
                  });
                }
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
            });

          });
        },
        toCode () {
          var _this = this;
          var i = 60;
          this.sendMsg = i + '秒';
            var nu = setInterval(function () {
              i--;
              _this.sendMsg = i + '秒';
              if (i === 0) {
                clearInterval(nu);
                _this.sendMsg = '发送验证码';
              }
            }, 1000);
        },
        sendyzm () {
          if (window._czc) {
            window._czc.push(['_trackEvent', '验证码', '点击', '发送验证码按钮', '1', '发送验证码按钮'])
          }
          var phonetest = /^1[0-9]{10}$/;
          var _this = this;
          if (this.sendMsg.length !== 5) {
            return;
          }
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            return;
          }
          this.getJy();
          this.codeshow = true;
          this.errorMsg = '请进行图片验证';
        },
        submit () {
          if (window._czc) {
            window._czc.push(['_trackEvent', '完成注册', '点击', '完成注册按钮', '1', '完成注册按钮'])
          }
          var _this = this;
          var phonetest = /^1[0-9]{10}$/;
          var emailtest = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-zd]{2,5}$/;
          var re = /^\d+$/;
          var re1 = /^[a-zA-Z]+$/;
          var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
          var val = this.password;
          var len = val.length;
          if (!this.isRead) {
            this.errorMsg = '请点击《图灵机器人开放平台服务协议》《图灵机器人开放平台隐私权政策》进行阅读后同意';
            return;
          }
          if (!this.onoff) {
            this.errorMsg = '请阅读并同意 《图灵机器人开放平台服务协议》《图灵机器人开放平台隐私权政策》';
            return;
          }
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            return;
          }
          if (this.email !== '' && !emailtest.test(this.email)) {
            this.errorMsg = '请输入正确邮箱格式';
            return;
          }
          if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
            this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
            return;
          }
          if (!this.code) {
            this.errorMsg = '验证码不能为空';
            return;
          }
          this.errorMsg = '';
          /* 判断手机是否已经注册 */
          this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              if (res.body.data === true) {
                _this.errorMsg = '该手机已经注册';
              } else {
                /* 判断邮箱是否已经注册 */
                _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.email}, {credentials: true}).then(function (res) {
                  if (res.body.type === 'success') {
                    if (res.body.data === true && _this.email !== '') {
                      _this.errorMsg = '该邮箱已经注册';
                    } else {
                      /* 判断手机号、验证码是否正确 */
                      _this.$http.post(_this.baseUrl + '/register/validate/1', {mobile: _this.telphone, code: _this.code}, {credentials: true}).then(function (res) {
                        if (res.body.type === 'success') {
                          /* 提交信息 */
                          var url = _this.baseUrl + '/register/save/4';
                          _this.$http.post(url, {
                            email: _this.email,
                            mobile: _this.telphone,
                            code: _this.code,
                            password: _this.password,
                            auto_login: true,
                            redirect_uri: '',
                            referer: _this.ReturnURl
                          }, {credentials: true}).then(function (res) {
                            if (res.body.type === 'success') {
                              window.location = _this.ReturnURl;
                            } else {
                              _this.errorMsg = '验证码错误';
                            }
                          }, function () {
                            _this.errorMsg = '网络错误，请稍后重试';
                          });
                        } else {
                          _this.errorMsg = '验证码错误';
                        }
                      }, function () {
                        _this.errorMsg = '网络错误，请稍后重试';
                      });
                    }
                  }
                }, function () {
                  _this.errorMsg = '网络错误，请稍后重试';
                });
              }
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
          });
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  @import '../../css/public.scss';
  .register{
    height: 660px;
    .con-wrap {
      .wrong.active {
        height: 36px;
        background: url("../../img/wrong.svg") left 2px no-repeat;
      }
    }
  }
  .register.height{
    height: 710px;
  }
  .clearfix span{
    color:#666;
  }
  .tit-box{
    display: block;
  }
  .tit{
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// register.vue?441a490a